<template>
  <div>
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <header-card
        icon="groups"
        title="Meeting Management"
        sub-title="Your one place to prepare and perform constructive meetings"
      >
        <template v-slot:right>
          <div class="secondary--text font-weight-medium subtitle-1">
            Total Completed Meetings
          </div>
          <div>
            {{ overview.totalCompleted }}
          </div>
        </template>
        <template v-slot:extension>
          <v-divider></v-divider>
          <v-row dense>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
              <v-text-field
                v-model="search"
                placeholder="Search for a meeting"
                solo
                flat
                prepend-inner-icon="search"
                hide-details
                clearable
              >
              </v-text-field>
            </v-col>
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-btn text color="secondary" @click="showDialog" block>
                <v-icon color="performance" class="mr-2">
                  add_circle
                </v-icon>
                Talking Point
              </v-btn>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-select
                v-model="active"
                flat
                solo
                hide-details
                :items="activeItems"
                item-text="name"
                item-value="id"
                class="min-width subtitle-2 font-weight-regular"
              ></v-select>
            </v-col>
            <v-divider vertical></v-divider>
          </v-row>
        </template>
      </header-card>
      <v-row>
        <v-col cols="12" sm="6" lg="4" v-if="active">
          <v-card
            height="100%"
            @click="
              editCheckin({ attendees: [profile], createdBy: profile.id })
            "
          >
            <v-card-text class="mt-6">
              <v-img
                class="mx-auto"
                :src="$images.CREATE_MEETING"
                width="85"
              ></v-img>
            </v-card-text>
            <v-card-title class="d-block text-center">
              Create a meeting
            </v-card-title>
            <v-card-subtitle class="text-center subtitle-2 mx-4">
              Organize your thoughts, collaborate on goals, stay aligned & much
              more
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col
          v-for="(item, i) in filtered_checkins"
          :key="i"
          cols="12"
          sm="6"
          lg="4"
        >
          <check-in-list-card
            :checkin="item"
            v-on:edit="editCheckin(item)"
            v-on:editattendees="editAttendees(item)"
          ></check-in-list-card>
        </v-col>
      </v-row>
    </template>
    <add-talking-point-dialog
      ref="addTalkingPoint"
      v-on:save="loadData"
    ></add-talking-point-dialog>
    <edit-check-in-dialog
      ref="editCheckin"
      v-on:save="loadData"
      v-on:add="goToMeeting"
    ></edit-check-in-dialog>
    <edit-check-in-attendees-dialog
      ref="editCheckinAttendees"
      v-on:save="loadData"
    ></edit-check-in-attendees-dialog>
  </div>
</template>

<script>
import CheckInListCard from "@/components/checkin/CheckInListCard";
import { mapGetters } from "vuex";
import HeaderCard from "@/components/common/HeaderCard";
import AddTalkingPointDialog from "@/components/checkin/AddTalkingPointDialog";
import EditCheckInDialog from "@/components/checkin/EditCheckInDialog";
import EditCheckInAttendeesDialog from "@/components/checkin/EditCheckInAttendeesDialog";
export default {
  name: "CheckInList",
  components: {
    CheckInListCard,
    HeaderCard,
    AddTalkingPointDialog,
    EditCheckInDialog,
    EditCheckInAttendeesDialog
  },
  props: {},
  data: () => ({
    search: "",
    loading: false,
    active: true,
    activeItems: [
      { id: true, name: "Active" },
      { id: false, name: "Archived" }
    ]
  }),
  computed: {
    filtered_checkins() {
      let checkins = this.checkins;

      if (this.active) {
        checkins = this.checkins.filter(x => x.archiveDate == null);
      } else {
        checkins = this.checkins.filter(x => x.archiveDate != null);
      }

      if (this.search) {
        let search = this.search.toLowerCase();
        checkins = checkins.filter(
          x => x.name.toLowerCase().indexOf(search) >= 0
        );
      }
      return this._.orderBy(
        checkins,
        ["startDate", "lastCheckInDays", "hasUrgentTalkingPoint"],
        ["asc", "desc", "desc"]
      );
    },
    ...mapGetters({
      overview: "checkin/overview",
      checkins: "checkin/list",
      profile: "profile/profile"
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([this.$store.dispatch("checkin/getCheckIns")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your meetings."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showDialog() {
      this.$refs.addTalkingPoint.showDialog();
    },
    editCheckin(checkin) {
      this.$refs.editCheckin.showDialog(checkin);
    },
    editAttendees(checkin) {
      this.$refs.editCheckinAttendees.showDialog(checkin);
    },
    goToMeeting(id) {
      this.$router.push({ path: `/meetings/${id}` });
    }
  }
};
</script>
